import type { MapListingEntry } from "@/lib/types";
import type { ApiOutput } from "@repo/api/trpc/router";
import type { ClusterPoint } from "@repo/maps";

export type MapAreaEntry =
  ApiOutput["listings"]["getMapListings"]["areas"][number];

export type AreaMapPoint = {
  kind: "area";
  area: MapAreaEntry;
  lat: number;
  lng: number;
};

export type SearchMapPoint = ClusterPoint<MapListingEntry> | AreaMapPoint;

export function isAreaMapPoint(point: SearchMapPoint): point is AreaMapPoint {
  return "kind" in point && point.kind === "area";
}
